/* tslint:disable */
import {
  Player,
  Organization,
  PlayerPrize
} from '../index';

declare var Object: any;
export interface InquiryInterface {
  "playerId": any;
  "subject"?: string;
  "message": string;
  "type"?: string;
  "readByAdmin"?: boolean;
  "readByUser"?: boolean;
  "id"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  "organizationId"?: any;
  "playerPrizeId"?: any;
  player?: Player;
  organization?: Organization;
  playerPrize?: PlayerPrize;
}

export class Inquiry implements InquiryInterface {
  "playerId": any;
  "subject": string;
  "message": string;
  "type": string;
  "readByAdmin": boolean;
  "readByUser": boolean;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  "organizationId": any;
  "playerPrizeId": any;
  player: Player;
  organization: Organization;
  playerPrize: PlayerPrize;
  constructor(data?: InquiryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Inquiry`.
   */
  public static getModelName() {
    return "Inquiry";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Inquiry for dynamic purposes.
  **/
  public static factory(data: InquiryInterface): Inquiry{
    return new Inquiry(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Inquiry',
      plural: 'inquiries',
      path: 'inquiries',
      idName: 'id',
      properties: {
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "subject": {
          name: 'subject',
          type: 'string'
        },
        "message": {
          name: 'message',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string',
          default: 'general'
        },
        "readByAdmin": {
          name: 'readByAdmin',
          type: 'boolean',
          default: false
        },
        "readByUser": {
          name: 'readByUser',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "organizationId": {
          name: 'organizationId',
          type: 'any'
        },
        "playerPrizeId": {
          name: 'playerPrizeId',
          type: 'any'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        organization: {
          name: 'organization',
          type: 'Organization',
          model: 'Organization',
          relationType: 'belongsTo',
                  keyFrom: 'organizationId',
          keyTo: 'id'
        },
        playerPrize: {
          name: 'playerPrize',
          type: 'PlayerPrize',
          model: 'PlayerPrize',
          relationType: 'belongsTo',
                  keyFrom: 'playerPrizeId',
          keyTo: 'id'
        },
      }
    }
  }
}
